/**
 * Üye API kökü (Auth, profil vb.).
 * Üretim / farklı ortam için `.env` içinde `REACT_APP_API_BASE_URL` tanımlayın.
 */
export const API_BASE_URL = (
    process.env.REACT_APP_API_BASE_URL || 'https://istanbulrotary.org/api'
).replace(/\/$/, '');

/**
 * Dış site CMS (haberler vb.) — üye API kökünden bağımsız.
 * Varsayılan `/api`: yerelde `setupProxy.js` → rotary.codiatest.com; canlıda aynı kök.
 * Farklı host için: `REACT_APP_PUBLIC_CMS_API_BASE_URL=https://rotary.codiatest.com/api`
 */
export const PUBLIC_CMS_API_BASE_URL = (
    process.env.REACT_APP_PUBLIC_CMS_API_BASE_URL || '/api'
).replace(/\/$/, '');

/**
 * CMS kapak yolları (`/api/cms/...`). Boş kök = göreli URL (proxy / aynı origin).
 */
export const PUBLIC_CMS_ASSET_ORIGIN = (
    process.env.REACT_APP_PUBLIC_CMS_ASSET_ORIGIN ??
    (process.env.REACT_APP_PUBLIC_CMS_API_BASE_URL
        ? PUBLIC_CMS_API_BASE_URL.replace(/\/api\/?$/, '') ||
        'https://rotary.codiatest.com'
        : '')
).replace(/\/$/, '');

/**
 * CMS kapak yolları (`/api/cms/...`) için kök; `API_BASE_URL` sonundaki `/api` kırpılır.
 * Gerekirse `.env` ile `REACT_APP_API_ASSET_ORIGIN` verin.
 */
export const API_ASSET_ORIGIN = (
    process.env.REACT_APP_API_ASSET_ORIGIN ||
    API_BASE_URL.replace(/\/api\/?$/, '') ||
    'https://istanbulrotary.org'
).replace(/\/$/, '');

/**
 * Üye alanı — galeri kapakları (`/api/cms/...` altında).
 * Örn. `REACT_APP_GALLERY_CMS_MEDIA_PREFIX=https://rotary.codiatest.com/api/cms`
 */
export const GALLERY_CMS_MEDIA_PREFIX = (
    process.env.REACT_APP_GALLERY_CMS_MEDIA_PREFIX ||
    'https://istanbulrotary.org/api/cms'
).replace(/\/$/, '');

/**
 * `AllGallery` kapakları (`/AllGalleries/...` göreli yol).
 * Örn. `REACT_APP_GALLERY_MEDIA_PREFIX=https://rotary.codiatest.com/api/galleries`
 */
export const GALLERY_MEDIA_PREFIX = (
    process.env.REACT_APP_GALLERY_MEDIA_PREFIX ||
    `${API_BASE_URL}/galleries`
).replace(/\/$/, '');

/**
 * `GET /galleries/api/AllGallery/GetAll` — `coverImageUrl` tam URL.
 * @param {string | null | undefined} path
 * @returns {string}
 */
export function resolveGalleryMediaUrl(path) {
    if (!path) return '';
    const t = String(path).trim();
    if (/^https?:\/\//i.test(t)) return t;
    const p = t.startsWith('/') ? t : `/${t}`;
    return `${GALLERY_MEDIA_PREFIX}${p}`;
}

/**
 * Galeri API’sinden gelen göreli kapak yolunu tam URL yapar.
 * @param {string | null | undefined} path
 * @returns {string}
 */
export function resolveGalleryCmsMediaUrl(path) {
    if (!path) return '';
    const t = String(path).trim();
    if (/^https?:\/\//i.test(t)) return t;
    const p = t.startsWith('/') ? t : `/${t}`;
    return `${GALLERY_CMS_MEDIA_PREFIX}${p}`;
}

/**
 * @param {string | null | undefined} path
 * @returns {string}
 */
export function resolvePublicMediaUrl(path) {
    if (!path) return '';
    const t = String(path).trim();
    if (/^https?:\/\//i.test(t)) return t;
    const p = t.startsWith('/') ? t : `/${t}`;
    return `${API_ASSET_ORIGIN}${p}`;
}

/**
 * Dış site CMS haber / proje kapakları.
 * @param {string | null | undefined} path
 * @returns {string}
 */
export function resolvePublicCmsMediaUrl(path) {
    if (!path) return '';
    const t = String(path).trim();
    if (/^https?:\/\//i.test(t)) return t;
    const p = t.startsWith('/') ? t : `/${t}`;
    return `${PUBLIC_CMS_ASSET_ORIGIN}${p}`;
}
